import 'aria-modal-dialog';
import './polyfills';
import initToggle from './components/data-toggle';
import initMouseFocusDetection from './components/using-mouse';
import initSubMenu from './components/menu';
import initSearch from './components/search';
import initSlatsExpanding from './components/slats';
import initSlider from './components/sliders';
import initDocumentsGrid from './components/documents-grid';
import initRates from './components/rates';
import initTabbedDiagram from './components/tabbed-diagram';

document.addEventListener('DOMContentLoaded', function() {
  initMouseFocusDetection();
  initToggle();
  initSubMenu();
  initSearch();
  initSlider();
  initSlatsExpanding();
  initDocumentsGrid();
  initRates();
  initTabbedDiagram();
});
